'use strict';

var connect = require('../../../modules/store/results').connect;
var viewInjectorUtils = require('../../../modules/views/view_injector_utils');
var createView = viewInjectorUtils.createView;
var SortingTabsView = require('./view');
var TabView = require('./tab.view');
var TabInfoView = require('./tab_info.view');

var defaultTemplate = function(textTemplate) {
    return Odigeo._.template(textTemplate, Odigeo.Utils.getTmplSettings());
};

var ConnectedSortingTabsView = connect(function(state) {
    return new Backbone.Model({
        translations: state.get('translations'),
    });
})(SortingTabsView);

var ConnectedTabView = connect(function(state) {
    return {
        sortingType: state.get('sortingModel'),
        translations: state.get('translations').get('sortingTabs'),
    };
})(TabView);

var ConnectedTabInfoView = connect(function(state, options) {
    return {
        info: state.get('topItineraries').get('best').get(options.type),
        formats: state.get('translations').get('formats'),
    };
})(TabInfoView);

var createTabs = function(viewFactories) {
    return createView(viewFactories, ConnectedSortingTabsView, {
        el: '.sorting_tabs',
        template: defaultTemplate(this._templates.sortingTabsContainerTemplate),
        tabTemplate: defaultTemplate(this._templates.sortingTabTemplate),
        tabInfoTemplate: defaultTemplate(this._templates.sortingTabInfoTemplate),
        tests: this.widget.options.tests,
    });
};

var createTabView = function(viewFactories, options) {
    return createView(viewFactories, ConnectedTabView, Odigeo._.defaults({
        el: options.selector,
        template: this.tabTemplate,
        infoTemplate: this.tabInfoTemplate,
    }, options));
};

var createTabInfoView = function(viewFactories) {
    return createView(viewFactories, ConnectedTabInfoView, {
        el: this.selector + ' .sorting_tab_data',
        type: this.sortType.value,
        template: this.infoTemplate,
    });
};

module.exports = viewInjectorUtils.createInjector({
    sortingTabs: createTabs,
    tab: createTabView,
    tabInfo: createTabInfoView,
});
